const storageKey = "splitterState";
const maxSessions = 10;

export type SmetaSplitterPersistedState = {
  sizes?: Record<number, number>;
  collapsed?: Record<number, boolean>;
};

type SplitterStateBySplitterId = Record<string, SmetaSplitterPersistedState>;

const getStorageMap = () => {
  const raw = localStorage.getItem(storageKey);
  return new Map<string, SplitterStateBySplitterId>(raw ? JSON.parse(raw) : []);
};

export const getSmetaSplitterState = (splitterId: string): SmetaSplitterPersistedState | undefined => {
  const licGUID = sessionStorage.getItem("LicG");
  if (!licGUID) return undefined;
  return getStorageMap().get(licGUID)?.[splitterId];
};

export const setSmetaSplitterState = (splitterId: string, state: SmetaSplitterPersistedState) => {
  const licGUID = sessionStorage.getItem("LicG");
  if (!licGUID) return;
  const map = getStorageMap();
  const existing = map.get(licGUID);
  if (existing) {
    map.delete(licGUID);
  } else if (map.size >= maxSessions) {
    const oldestKey = map.keys().next().value!;
    map.delete(oldestKey);
  }
  const existingSplitterState = existing?.[splitterId] ?? {};
  map.set(licGUID, {
    ...(existing ?? {}),
    [splitterId]: {
      sizes: { ...existingSplitterState.sizes, ...state.sizes },
      collapsed: { ...existingSplitterState.collapsed, ...state.collapsed },
    },
  });
  localStorage.setItem(storageKey, JSON.stringify(Array.from(map.entries())));
};
